"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderChangedNotifyType = exports.FutureOrderMode = exports.OrderPositionMode = exports.QueryOrderStatus = exports.OrderStatus = exports.OrderState = exports.OrderDirect = exports.InvestSymbolSide = exports.FutureWorkingType = exports.FuturePositionSide = exports.FutureMarginAction = exports.FutureTimeInForce = exports.FutureMarginType = exports.CustomOrderType = exports.ContractStatus = exports.ContractType = exports.CustomOrderSide = void 0;
/** 订单方向 */
var CustomOrderSide;
(function (CustomOrderSide) {
    CustomOrderSide["BUY"] = "buy";
    CustomOrderSide["SELL"] = "sell";
})(CustomOrderSide = exports.CustomOrderSide || (exports.CustomOrderSide = {}));
/**
 * 合约类型
 */
var ContractType;
(function (ContractType) {
    /**
     * 永续合约
     */
    ContractType["PERPETUAL"] = "PERPETUAL";
})(ContractType = exports.ContractType || (exports.ContractType = {}));
/**
 * 合约状态枚举
 * TRADING：交易中
 * OFFLINE：已下线
 */
var ContractStatus;
(function (ContractStatus) {
    ContractStatus["TRADING"] = "TRADING";
    ContractStatus["OFFLINE"] = "OFFLINE";
})(ContractStatus = exports.ContractStatus || (exports.ContractStatus = {}));
/** 订单类型 */
var CustomOrderType;
(function (CustomOrderType) {
    /** 限价单 */
    CustomOrderType["LIMIT"] = "limit";
    /** 市价单 (现货) */
    CustomOrderType["MARKET"] = "market";
    /** 市价单 (合约)，进入撮合前转为IOC订单 */
    CustomOrderType["MARKET_QTY"] = "market_qty";
    /** 立刻成交剩余取消订单 */
    CustomOrderType["IOC"] = "ioc";
    /** 全部成交否则取消订单 */
    CustomOrderType["FOK"] = "fok";
    /** 仅挂单 */
    CustomOrderType["POST"] = "post";
    /**触发后平仓 */
    CustomOrderType["CLOSE"] = "close";
})(CustomOrderType = exports.CustomOrderType || (exports.CustomOrderType = {}));
var FutureMarginType;
(function (FutureMarginType) {
    /**
     * 全仓模式
     */
    FutureMarginType["CROSS"] = "crossed";
    /**
     * 逐仓模式
     */
    FutureMarginType["ISOLATED"] = "isolated";
})(FutureMarginType = exports.FutureMarginType || (exports.FutureMarginType = {}));
var FutureTimeInForce;
(function (FutureTimeInForce) {
    /**
     * 成交为止
     */
    FutureTimeInForce["GTC"] = "GTC";
    /**
     * 无法立即成交(吃单)的部分就撤销
     */
    FutureTimeInForce["IOC"] = "IOC";
    /**
     * 无法全部立即成交就撤销
     */
    FutureTimeInForce["FOK"] = "FOK";
    /**
     * 无法成为挂单方就撤销
     */
    FutureTimeInForce["GTX"] = "GTX";
})(FutureTimeInForce = exports.FutureTimeInForce || (exports.FutureTimeInForce = {}));
var FutureMarginAction;
(function (FutureMarginAction) {
    /**
     * 增加保证金
     */
    FutureMarginAction["asc"] = "asc";
    /**
     * 提取保证金
     */
    FutureMarginAction["desc"] = "desc";
})(FutureMarginAction = exports.FutureMarginAction || (exports.FutureMarginAction = {}));
/**
 *
 * buy  不reduce    both buy    买入
 * sell   不reduce   both sell    卖出
 * buy  reduce      short buy    平空
 * sell   reduce       long sell     平多
 */
var FuturePositionSide;
(function (FuturePositionSide) {
    /**
     * 既可以影响多仓又可以影响空仓（默认)
     */
    FuturePositionSide["BOTH"] = "both";
    /**
     * 仅可影响多仓 ( sell long 就是平多, 也就是reduce only 多仓 )
     */
    FuturePositionSide["LONG"] = "long";
    /**
     * 仅可影响空仓 ( buy short 就是平空, 也就是reduce only 空仓 )
     */
    FuturePositionSide["SHORT"] = "short";
})(FuturePositionSide = exports.FuturePositionSide || (exports.FuturePositionSide = {}));
var FutureWorkingType;
(function (FutureWorkingType) {
    /**
     * 标记价格
     */
    FutureWorkingType["MARK_PRICE"] = "MARK_PRICE";
    /**
     * 合约最新价 (默认)
     */
    FutureWorkingType["CONTRACT_PRICE"] = "CONTRACT_PRICE";
})(FutureWorkingType = exports.FutureWorkingType || (exports.FutureWorkingType = {}));
var InvestSymbolSide;
(function (InvestSymbolSide) {
    InvestSymbolSide["base"] = "base";
    InvestSymbolSide["quote"] = "quote";
})(InvestSymbolSide = exports.InvestSymbolSide || (exports.InvestSymbolSide = {}));
/**订单查询的方向 */
var OrderDirect;
(function (OrderDirect) {
    /** 大于orderId的邻近订单（升序排列）：NEXT */
    OrderDirect["NEXT"] = "NEXT";
    /** 小于orderId的邻近订单（降序排列）：PREV */
    OrderDirect["PREV"] = "PREV";
})(OrderDirect = exports.OrderDirect || (exports.OrderDirect = {}));
/**订单状态 */
var OrderState;
(function (OrderState) {
    /**已提交 */
    OrderState["SUBMITTED"] = "SUBMITTED";
    /**已确认 */
    OrderState["CONFIRMED"] = "CONFIRMED";
    /**部分成交 */
    OrderState["PARTIAL_FILLED"] = "PARTIAL_FILLED";
    /**成交完成 */
    OrderState["FILLED"] = "FILLED";
    /** 全部撤销 */
    OrderState["CANCELED"] = "CANCELED";
    /** 部分成交已撤销 */
    OrderState["PARTIAL_CANCELED"] = "PARTIAL_CANCELED";
})(OrderState = exports.OrderState || (exports.OrderState = {}));
/**订单状态 */
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["OPEN"] = "open";
    OrderStatus["CANCELED"] = "canceled";
    OrderStatus["CLOSE"] = "closed";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
/**
 * 查询订单状态
 */
var QueryOrderStatus;
(function (QueryOrderStatus) {
    /** 全部成交 */
    QueryOrderStatus["CLOSED"] = "closed";
    /**全部撤销 */
    QueryOrderStatus["CANCELED"] = "canceled";
})(QueryOrderStatus = exports.QueryOrderStatus || (exports.QueryOrderStatus = {}));
var OrderPositionMode;
(function (OrderPositionMode) {
    /**买卖模式（单向模式） */
    OrderPositionMode["BUYSELL"] = "buysell";
    /**开平模式（双向模式） */
    OrderPositionMode["OPENCLOSE"] = "openclose";
})(OrderPositionMode = exports.OrderPositionMode || (exports.OrderPositionMode = {}));
var FutureOrderMode;
(function (FutureOrderMode) {
    /**用户发起-普通订单 */
    FutureOrderMode["NORMAL"] = "normal";
    /**系统生成-强平订单（盘内） */
    FutureOrderMode["LIQUIDATION"] = "liquidation";
    /**系统生成-自身多空对抵（盘外）*/
    FutureOrderMode["INNERMERGE"] = "innermerge";
    /**系统生成-强平队列多空对抵（盘外）*/
    FutureOrderMode["CROSSMERGE"] = "crossmerge";
    /**系统生成-系统接管（盘外）*/
    FutureOrderMode["TAKEOVER"] = "takeover";
})(FutureOrderMode = exports.FutureOrderMode || (exports.FutureOrderMode = {}));
var OrderChangedNotifyType;
(function (OrderChangedNotifyType) {
    /** 正常已完成 */
    OrderChangedNotifyType[OrderChangedNotifyType["complete"] = 1] = "complete";
    /** 成交量发生裁剪, 交易已完成 */
    OrderChangedNotifyType[OrderChangedNotifyType["qtyChangedComplete"] = 2] = "qtyChangedComplete";
    /** 成交量发生裁剪, 交易未完成 */
    OrderChangedNotifyType[OrderChangedNotifyType["qtyChangedNotComplete"] = 3] = "qtyChangedNotComplete";
    /** 市价单被IOC, 部分成交, 交易已完成 */
    OrderChangedNotifyType[OrderChangedNotifyType["marketBeenIOCComplete"] = 4] = "marketBeenIOCComplete";
    /** 市价单被IOC, 没成交, 交易失败 */
    OrderChangedNotifyType[OrderChangedNotifyType["marketBeenIOCCancelled"] = 5] = "marketBeenIOCCancelled";
})(OrderChangedNotifyType = exports.OrderChangedNotifyType || (exports.OrderChangedNotifyType = {}));
